// extracted by mini-css-extract-plugin
export default {"contentWrapper":"KnowledgeBasePage_contentWrapper__4bZ3U","wrapper":"KnowledgeBasePage_wrapper__-1vj7"};